<template>
  <div class="auth-loader">
    <div class="loader-circle">
      <div class="circle-outer"></div>
      <div class="circle-middle"></div>
      <div class="circle-inner"></div>
    </div>
    <div class="center-pulse"></div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'AuthLoader',
  });
</script>

<style scoped>
  .auth-loader {
    position: relative;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-circle {
    position: relative;
    width: 80px;
    height: 80px;
  }

  .circle-outer,
  .circle-middle,
  .circle-inner {
    position: absolute;
    border-radius: 50%;
    border-style: solid;
    animation: rotate 3s linear infinite;
  }

  .circle-outer {
    width: 80px;
    height: 80px;
    border: 3px solid transparent;
    border-top: 3px solid #f89d2a;
    border-right: 3px solid #f89d2a;
    animation-duration: 2s;
    opacity: 0.8;
  }

  .circle-middle {
    width: 60px;
    height: 60px;
    top: 10px;
    left: 10px;
    border: 2px solid transparent;
    border-bottom: 2px solid #ff6b35;
    border-left: 2px solid #ff6b35;
    animation-duration: 1.5s;
    animation-direction: reverse;
    opacity: 0.6;
  }

  .circle-inner {
    width: 40px;
    height: 40px;
    top: 20px;
    left: 20px;
    border: 2px solid transparent;
    border-top: 2px solid #4a90e2;
    animation-duration: 1s;
    opacity: 0.4;
  }

  .center-pulse {
    position: absolute;
    width: 16px;
    height: 16px;
    background: radial-gradient(circle, #f89d2a 0%, #ff6b35 100%);
    border-radius: 50%;
    animation: pulse 2s ease-in-out infinite;
    box-shadow: 0 0 20px rgba(248, 157, 42, 0.4);
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.3);
      opacity: 1;
    }
  }
</style>
